import { createFormAction } from 'redux-form-saga';
import * as productCategoryTRFormTypes from './productCategoryTRFormTypes';

export const submitProductCategoryTRForm = createFormAction(productCategoryTRFormTypes.SUBMIT_PRODUCT_CATEGORY_TR_FORM);
